<script setup>
    import { ref, computed, onMounted, getCurrentInstance } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue'
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import insightsNewsletterService from "../../../../user/services/insights/insightsNewsletterService";
    import mailMsgServcie from "../../../services/mail/mailMsgServcie";
    import { useAlertStore } from '../../../../../stores/alertStore';
    const { $alert, $confirm } = useAlertStore();
    
    const route = useRoute()
    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const {$toast} = getCurrentInstance().appContext.config.globalProperties;

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            goBack()
        } else {
            retrieveDetail(id)
        }
    })

    const newsletter = ref({
        attachList: [],
    });

    const retrieveDetail = (id) => {
        loadingStore.loading = true;
        insightsNewsletterService.retrieveNewsletterDetail(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    // console.log(result);
                    newsletter.value = result;
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            // console.log(error);
        });
    }

    const onClickDelete = async () => {
        const ok = await $confirm(["뉴스레터를 삭제할까요?", "삭제 시 사용자 사이트에 즉시 적용되며 되돌릴 수 없습니다."], "삭제");
        if(ok){
            deleteNewsletter()
        }
    }

    function deleteNewsletter() {
        loadingStore.loading = true;
        insightsNewsletterService.deleteNewsletter(newsletter.value.newsletterId)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    goBack();
                } else {
                    $alert("삭제를 실패하였습니다.");
                }
            }).catch( (res) =>  {
            loadingStore.loading = false;
            // console.log(res);
            $alert("삭제를 실패하였습니다.");
        });
    }

    const onClickSend = async () => {
        const ok = await $confirm(["뉴스레터를 전송할까요?"], "전송");
        if(ok) {
            sendNewsletter();
        }
    }

    function sendNewsletter() {
        loadingStore.loading = true;
        mailMsgServcie.requestSendEmailNewsletter(newsletter.value.newsletterId)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    $toast('', "뉴스레터를 전송하였습니다.<br/>'메일/메시지 관리' > '전송 내역'에서 확인할 수 있습니다.");
                } else {
                    $alert("전송을 실패하였습니다.");
                }
            }).catch( (res) =>  {
            loadingStore.loading = false;
            // console.log(res);
            $alert("전송을 실패하였습니다.");
        });
    }

    const onClickUpdate = () => {
        router.push({name:'CSNewsletterUpdate', params:{id: newsletter.value.newsletterId}})
    }

    const goBack = () => {
        router.push({name:'CSNewsletterList'})
    }

    const convertContent = (content) => {
        if(content && !content.includes("<img style=\"max-width:1200px; height:auto;")) {
            return content.replace("<img ", '<img style=\"max-width:1200px; height:auto; \" ')
        }
        return content || "";
    }
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>뉴스레터</h3>
        </div>
        <div class="btn-wrap space-between mb-xs">
            <div>
                <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
                <KSAPrimaryButton text="뉴스레터 전송" @click="onClickSend" />
            </div>
            <div>
                <KSASecondaryButton text="수정" @click="onClickUpdate" />
                <KSASecondaryButton class="red_button" text="삭제" @click="onClickDelete" />
            </div>
        </div>
        <div class="board-detail">
            <div class="header">
                <div class="thumb-wrap">
                    <KSAImage v-if="newsletter.newsletterThumbDir" :src="newsletter.newsletterThumbDir" />
                    <div v-else class="no-image"><p>이미지 없음</p></div>
                </div>
                <div class="info">
                    <div class="board-title">
                        <p>{{ newsletter.title }} <img v-if="newsletter.attachList.length > 0 && newsletter.attachList[0].fileName" src="/src/assets/images/icon-file.png" class="icon-file" /></p>
                    </div>
                    <span>작성일 <i>{{ $yyyymmddOrHHmm(newsletter.createDate) }}</i></span>
                    <span>작성자
                        <i>
                            {{ newsletter.createUserName }}<span v-if="newsletter.createUserLoginId">({{ newsletter.createUserLoginId }})</span>
                        </i>
                    </span>
                    <span>조회수 <i>{{ $number(newsletter.hitCount)}}</i></span>
                </div>
            </div>
            <div class="body">
                <div class="text">
                    <p v-html="convertContent(newsletter.content)"></p>
                </div>
            </div>
            <div class="control">
                <dl class="download" v-if="newsletter.attachList.length > 0 && newsletter.attachList[0].fileName"  v-for="attach in newsletter.attachList">
                    <dt>첨부</dt>
                    <dd>
                        <div>
                            {{ attach.fileName }}
                            <KSATextButton v-if="attach.fileDir" class="ml-xs" text="다운로드" @click="$download(attach.fileDir)" />
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .thumb-wrap {
    margin: 0 40px 0 0;
  }
}
</style>